import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Yard Management Module Service Stores
 */
export const yardStores: ServiceStoreConfig[] = [
  {
    name: "yard-locations",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "yard-inventory-items",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "yard-movement-logs",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "yard-maps",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "yard-map-location-assignments",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
];